import classNames from 'classnames';
import type React from 'react';
import styles from './index.module.scss';

export type EvaluationPassRateProps = {
  score: number | null | undefined;
  isActive?: boolean;
};

export const EvaluationPassRate: React.FC<EvaluationPassRateProps> = ({
  score,
  isActive = true,
}) => {
  const displayScore = score ?? '-';

  return (
    <div
      className={classNames(styles.scoreValue, {
        [styles.active]: isActive,
      })}
    >
      <span className={styles.score}>{displayScore}</span>
      <span className={styles.scoreUnit}>%</span>
    </div>
  );
};
